import { render, staticRenderFns } from "./tabbar2.vue?vue&type=template&id=31f4d049&scoped=true"
import script from "./tabbar2.vue?vue&type=script&lang=js"
export * from "./tabbar2.vue?vue&type=script&lang=js"
import style0 from "./tabbar2.vue?vue&type=style&index=0&id=31f4d049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4d049",
  null
  
)

export default component.exports